import * as React from 'react';

import { Subscribe, SubscribeProps } from 'unstated';
import { DashboardType, SearchQuery } from '../types';
import { mapQuerystringToQuery } from '../utils';

import { Main } from '../../BaseLayout/components/base-layout/main';
import { ConnectedDashboard, Props as DashboardProps } from '../container/Dashboard';
import { navigateWithQuery, SearchContainer } from '../../BaseLayout/container/SearchContainer';
import { CElement, ReactNode } from 'react';

export interface Props {
  entity: DashboardType;
}

export function ConnectedDashboardPage(props: Props): CElement<SubscribeProps, Subscribe> {
  const getRenderProps = (container: SearchContainer): DashboardProps => {
    const { entity } = props;
    const searchQuery: SearchQuery = mapQuerystringToQuery(document.location.search);

    return {
      entity,
      searchQuery,
      embedded: false,
      onSearchQueryUpdate: (value: SearchQuery, initial: boolean) => {
        void container.setSearchTerm(undefined !== value.q ? value.q : '');
        navigateWithQuery(entity, value, initial);
      },
      onDidMount: () => {
        // NOTE: This relies on the key prop of the ConnectedDashboard being updated
        // when entity prop changes to force a remount.
        // Otherwise, onDidMount will not be called and the search won't be refreshed
        void container.setContext(entity);
        void container.setVisibleSearchTerm(undefined !== searchQuery.q ? searchQuery.q : '');
        void container.setSearchTerm(undefined !== searchQuery.q ? searchQuery.q : '');
      },
    };
  };

  // Return the stateless DashboardPage component wrapped in a Subscriber
  return React.createElement(Subscribe, {
    to: [SearchContainer],
    children: (c: SearchContainer): ReactNode => {
      // Get the render props using the state container
      const _props: DashboardProps = getRenderProps(c);
      return (
        <Main>
          <ConnectedDashboard key={_props.entity} {..._props} />
        </Main>
      );
    },
  });
}

export default ConnectedDashboardPage;
